var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 17.9173C14.3722 17.9173 17.9166 14.3729 17.9166 10.0007C17.9166 5.6284 14.3722 2.08398 9.99992 2.08398C5.62766 2.08398 2.08325 5.6284 2.08325 10.0007C2.08325 14.3729 5.62766 17.9173 9.99992 17.9173ZM8.232 8.31092C8.61046 8.52985 9.09475 8.40052 9.31368 8.02206C10.0713 6.92534 11.5358 8.38565 10.3351 9.09945C10.1192 9.22776 9.837 9.44132 9.62233 9.70294C9.41905 9.95065 9.23236 10.2913 9.2104 10.71C9.20761 10.7371 9.20618 10.7645 9.20618 10.7923C9.20618 11.2295 9.56062 11.584 9.99784 11.584C10.6013 11.584 10.7162 11.2634 10.8321 10.9399C10.9066 10.7318 10.9816 10.5224 11.1874 10.3965C11.8418 9.99589 12.3749 9.28635 12.3749 8.41732C12.3749 7.10564 11.3116 6.04232 9.99992 6.04232C9.11984 6.04232 8.35259 6.52142 7.94314 7.22924C7.72421 7.60771 7.85353 8.09199 8.232 8.31092ZM9.20618 13.1673C9.20618 12.7301 9.56062 12.3757 9.99784 12.3757C10.4351 12.3757 10.7895 12.7301 10.7895 13.1673C10.7895 13.6045 10.4351 13.959 9.99784 13.959C9.56062 13.959 9.20618 13.6045 9.20618 13.1673Z",
    fill: "#385BF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.0156ce42007b2829ab3446a1e24652b2.svg";
export { ForwardRef as ReactComponent };